import { Padding } from 'componentregistry';
import { CSSProperties, useMemo } from 'react';

function getPadding(value: number): string {
  return `${value}px`;
}

export type CSSPadding = Pick<
  CSSProperties,
  'padding' | 'paddingLeft' | 'paddingRight' | 'paddingBottom' | 'paddingTop'
>;

export default function usePadding(padding?: Padding): CSSPadding {
  return useMemo(() => {
    const style: CSSPadding = {};
    if (typeof padding === 'number') {
      style.padding = getPadding(padding);
    } else if (typeof padding?.all === 'number') {
      style.padding = getPadding(padding.all);
    } else {
      if (typeof padding?.top === 'number') {
        style.paddingTop = getPadding(padding.top);
      }
      if (typeof padding?.right === 'number') {
        style.paddingRight = getPadding(padding.right);
      }
      if (typeof padding?.bottom === 'number') {
        style.paddingBottom = getPadding(padding.bottom);
      }
      if (typeof padding?.left === 'number') {
        style.paddingLeft = getPadding(padding.left);
      }
    }
    return style;
  }, [padding]);
}
